"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CONFIG = exports.DEFAULT_TRACKED_EVENT_DETAILS = exports.DEFAULT_STATIC_DIMENSIONS = exports.DEFAULT_UNKNOWN = void 0;
const events_1 = require("./events");
const webVitals_1 = require("./webVitals");
exports.DEFAULT_UNKNOWN = 'UNKNOWN';
/**
 * Default static dimensions to be sent with every beacon.
 *
 * @todo Validate that `beaconUrl`, `pageName`, `environment`, and `platform`
 *   are set in initConfig() and log warnings if not. Additionally, set `ua` in
 *   initConfig() so we're not calculating this on startup. See PERF-844.
 */
exports.DEFAULT_STATIC_DIMENSIONS = {
    pageName: exports.DEFAULT_UNKNOWN,
    environment: exports.DEFAULT_UNKNOWN,
    platform: exports.DEFAULT_UNKNOWN,
    // Automatically set the user agent if available and if we're in a browser
    // environment. See PERF-802.
    ua: (typeof window !== 'undefined' && ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent)) ||
        undefined,
    // Set defaults for legacy options to required values
    serviceName: 'pre',
    serviceVersion: 'ALL',
};
/** Default event details including for Web Vitals metrics */
exports.DEFAULT_TRACKED_EVENT_DETAILS = [
    ...webVitals_1.WEB_VITALS_EVENT_DETAILS,
    {
        [events_1.EVENT_NAMES.CLIENT_PROFILER_LOADED]: { dynamicEvent: true },
    },
];
/**
 * Default Client Profiler configuration.
 * @todo Remove `trackedEventDetails` once all built-in events are registered
 *   via `registerEvent()`. See PERF-836.
 */
exports.DEFAULT_CONFIG = {
    pageLoadBeaconDelay: 100,
    staticDimensions: exports.DEFAULT_STATIC_DIMENSIONS,
    trackedEventDetails: { eventDetails: exports.DEFAULT_TRACKED_EVENT_DETAILS },
};
